import { render, staticRenderFns } from "./LinkedAccountDetails.vue?vue&type=template&id=3338f168&scoped=true"
import script from "./LinkedAccountDetails.vue?vue&type=script&lang=js"
export * from "./LinkedAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./LinkedAccountDetails.vue?vue&type=style&index=0&id=3338f168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338f168",
  null
  
)

export default component.exports